import { POS_STATE_KEY, PosState } from './pos-reducer';

export enum POS_ACTION_TYPE {
  SET_POS_STATE = 'SET_POS_STATE',
  CALL_POS_FOOD_MENU = 'CALL_POS_FOOD_MENU'
}

export type SetPosStateAction<KeyName extends keyof PosState> = {
  type: POS_ACTION_TYPE.SET_POS_STATE;
  payload: { key: KeyName, value: PosState[KeyName] };
};


export type PosActions = SetPosStateAction<POS_STATE_KEY>;
